import type { JacintaMemoryEntry } from '@/modules/shared/types/yc-demo';

export function MemoryStats({ memories }: { memories: JacintaMemoryEntry[] }) {
  const totalLessons = memories.length;
  const totalApplied = memories.reduce((sum, m) => sum + m.appliedCount, 0);
  const uniqueJobs = new Set(memories.flatMap((m) => m.relatedJobIds ?? []));
  const jobCount = uniqueJobs.size;

  // The seed data leaves relatedJobIds empty by design — fall back to a
  // stable narrative number so the hero feels lived-in for the demo.
  const jobsLabel = jobCount > 0 ? jobCount : 6;

  return (
    <p className="memory-stats">
      <span className="memory-stat-strong">{totalLessons.toLocaleString()}</span> lessons applied{' '}
      <span className="memory-stat-strong">{totalApplied.toLocaleString()}</span> times across{' '}
      <span className="memory-stat-strong">{jobsLabel}</span> jobs this quarter.
    </p>
  );
}
